module.exports={Remove:"削除"};